import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function AppShell() {
  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 ml-56">
        <main
          data-testid="app-main"
          className="flex-1 overflow-auto bg-[#F8F9FA] dark:bg-background"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
